import { Box, Card, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PintIcon } from 'assets/custom_icons/customIcons';
import type { FC } from 'react';
import type { IIsPdf } from '../../models';
import { AvaniLightTheme } from '../../theme/schemes/AvaniLightTheme';
import { AvaniNumberSpin } from '../DataDisplay';

interface AvaniSavedPintsCardProps extends IIsPdf {
  title: string;
  savedPintsValue: number;
  text?: string;
  small?: boolean;
  sx?: any;
}

const AvaniSavedPintsStyledCard = styled(Card)(
  () => `
  border-radius: 16px;
  padding: 16px;
  height: 100%;

  .MuiTypography-root.MuiTypography-h3 {
    margin: 0;
    line-height: 1;
    padding-bottom: 12px;
    display: block;
    width: 100%;
    float: left;
  }

  .MuiTypography-root.MuiTypography-h3.noText {
    padding-bottom: 0;
  }

  &.AvaniBeerCard {
    .AvaniCardContent .MuiTypography-root.MuiTypography-h3 {
      float: left;
      width: 100%;
      margin-top: 28px;
      padding-bottom: 16px;
    }
  }

  .animated-container {
    margin-top: -20px;
  }
`
);

export const AvaniSavedPintsCard: FC<AvaniSavedPintsCardProps> = ({
  title,
  savedPintsValue,
  text,
  small,
  sx,
  isPDF = false
}) => {
  const theme = isPDF ? AvaniLightTheme : useTheme();

  return (
    <AvaniSavedPintsStyledCard
      raised={true}
      sx={{
        height: '100%',
        backgroundColor: theme.colors.avani.lightTurc,
        ['.SavedBeerSpinner']: {
          textAlign: 'right',
          marginTop: 0
        },
        minHeight: '183px',
        maxHeight: '183px',
        ...sx
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          textAlign: 'center'
        }}
      >
        <AvaniNumberSpin
          numberValue={savedPintsValue}
          fSize={small ? 40 : 50}
          sx={{ marginTop: '12px', marginRight: '12px' }}
          isPDF={isPDF}
        />
        <Box>{PintIcon({ width: 42, height: 42, isPDF })}</Box>
      </div>
      <Typography variant="h3" className={!text ? 'noText' : ''} color={theme.colors.avani.teal}>
        {title}
      </Typography>
      {text && (
        <Typography variant="body2" fontSize={14} lineHeight={1}>
          {text}
        </Typography>
      )}
    </AvaniSavedPintsStyledCard>
  );
};
